import axios from "axios";

// PATHS
const RA_DATA = '/network/ra/';
const DMS_TIME_FRAMES = 'network/ra/extensions/dms-timeframes?dmsCode={dmsCode}';
const SAVE_EXTENSION = '/network/ra';
const CREATE_EXTENSION = '/network/ra/extension';
const RA_EXTRA_DAYS = '/network/pricing/calculate-extra-days';

const fetchRaData = async (req: any): Promise<any> => {
    const response =  await axios.get(RA_DATA + req.idRentalAgreement);
    return response.data;
}

/**
 * Fetch dms time frames
 * @param payload - dmsCode
 */
const fetchDmsTimeFrames = async (payload: {dmsCode: string}): Promise<any> => {
    const response =  await axios.get(DMS_TIME_FRAMES.replace('{dmsCode}', payload.dmsCode));
    return response.data;
}

/**
 * Used for RA without offerId
 * @param params
 */
const saveExtension = async (params: any): Promise<any> => {
    const response = await axios.post(SAVE_EXTENSION, params);
    return response.data;
}

const createExtension = async (params: any): Promise<any> => {
    const response = await axios.post(CREATE_EXTENSION, params);
    return response.data;
}

/** Get Extra Km & Extra Days*/
const fetchExtensionDays: any = async (params: any) => {
    const response = await axios.post(RA_EXTRA_DAYS, params);
    return response.data;
}

export {
    fetchExtensionDays,
    fetchDmsTimeFrames,
    fetchRaData,
    saveExtension,
    createExtension
}